import { useEffect, useState } from "react";
import {
  getPendingPwaUpdate,
  PWA_UPDATE_EVENT,
  type PwaUpdateEventDetail,
} from "./events";

export function PwaUpdatePrompt() {
  const [applyUpdate, setApplyUpdate] = useState<
    PwaUpdateEventDetail["applyUpdate"] | null
  >(() => getPendingPwaUpdate()?.applyUpdate ?? null);
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    const handleUpdate = (event: Event) => {
      const { applyUpdate: nextApplyUpdate } = (
        event as CustomEvent<PwaUpdateEventDetail>
      ).detail;
      setApplyUpdate(() => nextApplyUpdate);
    };

    window.addEventListener(PWA_UPDATE_EVENT, handleUpdate);
    return () => window.removeEventListener(PWA_UPDATE_EVENT, handleUpdate);
  }, []);

  if (!applyUpdate) {
    return null;
  }

  const update = async () => {
    setIsApplying(true);
    try {
      await applyUpdate();
    } catch {
      setIsApplying(false);
    }
  };

  return (
    <aside
      aria-live="polite"
      className="fixed right-4 bottom-4 left-4 z-50 mx-auto flex max-w-md items-center gap-4 rounded-[20px] bg-[#171714] p-4 text-white shadow-[0_18px_50px_rgba(23,23,20,0.25)]"
    >
      <p className="flex-1 text-sm font-semibold">
        Доступна новая версия приложения
      </p>
      <button
        className="rounded-full bg-[#FF7A00] px-4 py-2 text-sm font-bold text-white disabled:opacity-60"
        disabled={isApplying}
        onClick={() => void update()}
        type="button"
      >
        {isApplying ? "Обновляем…" : "Обновить"}
      </button>
    </aside>
  );
}
